export default __webpack_public_path__ + "static/media/CNo.71-0.3ee90552.jpg";